import { InputSwitch } from "primereact/inputswitch";
import "./smallInputSwitch.css";
import React from "react";
import { SmallInputSwitchProps } from "../types/SmallInputSwitchProps";

export const SmallInputSwitch = ({
    checked,
    disabled,
    onChange
}: SmallInputSwitchProps) => (
    <InputSwitch
        checked={checked}
        disabled={disabled}
        className="p-inputswitch-small"
        onChange={(e) => onChange(e.value)}
    />
);
